import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

/**
 * htxChanged Partial Translate Cell
 * Translates htxChanged into available enum values
 */
export const htxPartialTable: Columns<any> = {
  title: 'HTX Rettet',
  key: 'htxChanged',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'meter.htx.notspecified',
    primary: 'meter.htx.primary',
    secondary: 'meter.htx.secondary',
  }

}
